import React from "react";
import {Box, Breadcrumbs, IconButton, Tooltip, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getHomeInternalUrl, getNodeInternalUrl} from "../../constants/appRoutes";
import CustomLink from "../custom-link";
import {hubSelector} from "../../state/hub/hubSelectors";
import {nodeCodeSelector, nodeNameSelector} from "../../state/node/nodeSelectors";
import "./style.css";

const PageTitle = ({
  // content props
  title,
  breadcrumbItems,
  actions = [],

  // styling props
  titleClassname = "",
  breadcrumbsClassname = "",

  // visibility flags
  hideTitle = false,
  hideBreadcrumbs = false,
  showTitleTooltip = false
}) => {
  const {t} = useTranslation();

  const hub = useSelector(hubSelector);
  const nodeCode = useSelector(nodeCodeSelector);
  const nodeName = useSelector(nodeNameSelector);

  return (
    <Box
      className="page-title"
      sx={{
        marginTop: theme => theme.spacing(1),
        marginBottom: theme => theme.spacing(2)
      }}
    >
      {!hideBreadcrumbs && (
        <Breadcrumbs
          aria-label={t("components.pageTitle.breadcrumbs.ariaLabel")}
          id="page-title__breadcrumbs"
          className={`page-title__breadcrumbs ${breadcrumbsClassname}`}
        >
          {hub && (
            <CustomLink
              key={"hub-home"}
              to={getHomeInternalUrl()}
              text={t("components.pageTitle.breadcrumbs.links.home")}
              textStyle={{padding: 0}}
              className="page-title__breadcrumbs__hub"
            />
          )}
          {nodeCode && (
            <CustomLink
              key={nodeCode}
              to={getNodeInternalUrl(nodeCode)}
              text={nodeName ?? nodeCode}
              textStyle={{padding: 0}}
              className="page-title__breadcrumbs__node"
            />
          )}
          {(breadcrumbItems || [])
            .filter(child => !!child)
            .map(({to, label}, idx) =>
              !!to ? (
                <CustomLink
                  key={idx}
                  to={to}
                  text={label}
                  textStyle={{padding: 0}}
                  className={`page-title__breadcrumbs__item-link-${idx}`}
                />
              ) : (
                <Box
                  key={idx}
                  component="span"
                  className={`page-title__breadcrumbs__item-${idx}`}
                  sx={{color: theme => theme.palette.text.primary}}
                >
                  {label}
                </Box>
              )
            )}
        </Breadcrumbs>
      )}
      {!hideTitle && (title || "").length > 0 && (
        <Box className="page-title__title-action-wrapper">
          <Box>
            <Tooltip title={showTitleTooltip ? title : ""}>
              <Typography
                variant="h1"
                component="h1"
                id="page-title__title"
                className={`page-title__title ${titleClassname}`}
              >
                <Box component="span" className="page-title__title-text">
                  {title}
                </Box>
              </Typography>
            </Tooltip>
          </Box>
          <Box>
            {actions
              .filter(a => a)
              .map(({icon, title, onClick}, idx) => (
                <Box key={idx} component="span" className="page-title__action">
                  <Tooltip title={title}>
                    <IconButton onClick={onClick}>{icon}</IconButton>
                  </Tooltip>
                </Box>
              ))}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default PageTitle;
